export default __webpack_public_path__ + "static/media/image2_200x200.66eb4955.png";